module.exports = __webpack_public_path__ + "static/media/mercadolivre-gray.f2ac73ff.svg";